import axios from "axios";
import Storage from "../../utills/AsyncStorage";
import { BASE_URL } from "../Apis";

const Axios = axios.create({
  baseURL: BASE_URL,
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      Storage.removeToken();
      localStorage.clear();

      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default Axios;
